import { useNavigate, useParams } from 'react-router-dom'
import { getClinicMenuData } from '@/data/menuData'
import { filterMenuItem } from '@/components/sidebar/filterMenuItem'
import { useMyPermissions } from '@/hooks/useMyPermissions'
import { useMe } from '@/hooks/useMe'
import { useClinicById } from '@/hooks/useClinicById'
import { PageHeader } from '@/components/PageHeader'

// 診所首頁：提供該診所各功能的快速入口。
// 入口項目與側邊選單共用同一份 menu data 與權限過濾（filterMenuItem），
// 確保首頁上看得到的功能與選單一致，不會出現點了 403 的入口。
export default function ClinicHomePage() {
  const navigate = useNavigate()
  const params = useParams()
  const clinicId = Number(params.clinic_id)
  const { clinic } = useClinicById(params.clinic_id)
  const { hasPermission, isLoading } = useMyPermissions()
  const { user } = useMe()

  const menuItems = Number.isFinite(clinicId)
    ? getClinicMenuData(clinicId).filter(
        (item) =>
          item.label !== '首頁' &&
          filterMenuItem(item, hasPermission, user?.role_type, user?.scopes, 'clinic'),
      )
    : []

  return (
    <div className="space-y-6">
      <PageHeader
        title={clinic?.clinic_name ? `${clinic.clinic_name} 首頁` : '診所首頁'}
        description="選擇要使用的功能"
        level="section"
      />

      {isLoading ? (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 animate-pulse">
          {[...Array(6)].map((_, index) => (
            <div key={index} className="h-28 bg-gray-200 rounded-md" />
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {menuItems.map((item) => (
            <button
              key={item.label}
              onClick={() => item.onClick(navigate)}
              className="bg-card border rounded-md p-4 flex flex-col items-center justify-center gap-2 hover:border-primary cursor-pointer transition-colors h-28"
            >
              <item.icon className="w-6 h-6 stroke-[#898989]" />
              <span className="text-sm font-medium">{item.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
